import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "tbody", "year"]

  connect() {
    this.setDefaultYear()
  }

  setDefaultYear() {
    const currentYear = new Date().getFullYear()
    this.yearTargets.forEach(input => {
      if (!input.value) {
        input.value = currentYear
      }
    })
  }

  addRow(e) {
    if (e) e.preventDefault()
    if (!this.hasTemplateTarget || !this.hasTbodyTarget) return

    const content = this.templateTarget.innerHTML
    this.tbodyTarget.insertAdjacentHTML('beforeend', content)
    
    this.setDefaultYear()
  }

  removeRow(e) {
    e.preventDefault()
    const row = e.target.closest("tr")
    if (row) {
      row.remove()
    }
  }
}
